var UtilSVG = /** @class */ (function () {
    function UtilSVG() {
        var _this = this;
        this.rectToEllipseToPath = function (rect, scale, margin) {
            var center = _this.rectCenter(rect);
            var delta = Math.min(rect.width, rect.height);
            var radius = {
                x: rect.width * scale + margin,
                y: delta * scale + margin,
            };
            return "M" + (center.x - radius.x) + "," + (center.y + delta / 2) + "a" + radius.x + "," + radius.y + " 0 1,0 " + radius.x * 2 + ",0a" + radius.x + "," + radius.y + " 0 1,0 -" + radius.x * 2 + ",0z";
        };
        this.rectToPixiEllipseToPath = function (rect, scale, margin) {
            var center = _this.pixiCenter(rect);
            var radius = {
                x: rect.width * scale + margin,
                y: rect.height * scale + margin,
            };
            return "M" + center.x + "," + center.y + "a" + radius.x + "," + radius.y + " 0 1,0 " + radius.x * 2 + ",0a" + radius.x + "," + radius.y + " 0 1,0 -" + radius.x * 2 + ",0z";
        };
        this.rectBasePath = function (top, bottom, left, right) {
            return "M" + top.x + " " + top.y + " L" + left.x + " " + left.y + " L" + bottom.x + " " + bottom.y + " L" + right.x + " " + right.y;
        };
        this.rectPath = function (x1, y1, x2, y2) {
            return "M" + x1 + " " + y1 + " h" + (x2 - x1) + " v" + (y2 - y1) + " h" + (x1 - x2) + " z";
        };
        this.screenViewportSize = function () {
            return {
                x: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
                y: Math.max(document.documentElement.clientHeight, window.innerHeight || 0),
            };
        };
        this.fullScreenPath = function (margin) {
            var screenViewportSize = _this.screenViewportSize();
            return _this.rectPath(0 - margin, 0 - margin, screenViewportSize.x + margin, screenViewportSize.y + margin);
        };
        this.pixiCenter = function (rect) {
            return {
                x: rect.left - rect.width / 2,
                y: rect.top,
            };
        };
        this.rectCenter = function (rect) {
            return {
                x: rect.left + rect.width / 2,
                y: rect.top,
            };
        };
    }
    return UtilSVG;
}());
export var utilSVG = new UtilSVG();



//////////////////
// WEBPACK FOOTER
// ./src/utils/svg/utilSVG.ts
// module id = 479
// module chunks = 3